module.exports = __webpack_public_path__ + "static/media/shallow_heaven.2e48a0b5.mp4";